import { gql } from "apollo-boost";

export const REGISTER_FOR_OPEN_HOUSE = gql`
  mutation register_for_open_house($open_house_id: ID!) {
    register_for_open_house(input: { open_house_id: $open_house_id }) {
      ... on RegisterOrDeregisterForOpenHouseResult {
        successful
      }
      ... on RegisterOrDeregisterForOpenHouseErrors {
        errors {
          message
          type
        }
      }
    }
  }
`;
